import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { MAP_INCIDENT_TYPE_TO_URL_PREFIX } from '../constants'
import { COMMENT_AND_TAGS_UPDATE_ASYNC } from '../ReportCommunicationModal/constants'

import { editTagsError, editTagsSuccess, fetchTagsError, fetchTagsSuccess } from './actions'
import { EDIT_TAGS_REQUEST_ASYNC, TAGS_REQUEST_ASYNC } from './constants'

const fetchTagsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(TAGS_REQUEST_ASYNC.INITIATE, COMMENT_AND_TAGS_UPDATE_ASYNC.SUCCESS)
    .mergeMap((action) =>
      api.resolutionCenter
        .fetchTags(
          action.payload.reportId,
          action.payload.reportState,
          MAP_INCIDENT_TYPE_TO_URL_PREFIX[action.payload.reportType]
        )
        .map((response) =>
          fetchTagsSuccess(response, action.payload.reportId, action.payload.reportType)
        )
        .catch((error) => Observable.of(epicsErrorHandler(fetchTagsError, error)))
        .takeUntil(action$.ofType(TAGS_REQUEST_ASYNC.CANCEL))
    )

const editTagsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(EDIT_TAGS_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.resolutionCenter
      .editTags(
        action.payload.reportId,
        action.payload.type,
        action.payload.tagsArr,
        MAP_INCIDENT_TYPE_TO_URL_PREFIX[action.payload.reportType]
      )
      .map(() => editTagsSuccess(action.payload.tagsArr, action.payload.reportId))
      .catch((error) => Observable.of(epicsErrorHandler(editTagsError, error)))
      .takeUntil(action$.ofType(EDIT_TAGS_REQUEST_ASYNC.CANCEL))
  )

export default combineEpics(fetchTagsEpic, editTagsEpic)
